import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNominaActivaComboBox } from "../../../../../redux/actions/nomina";
import { addTrabajador, getSectores, getSustancias, removeTrabajadores } from "../../../../../redux/actions/resolucion";
import TrabajadoresFormContainer from "./TrabajadoresFormContainer";
import TrabajadoresSectorTable from "./TrabajadoresSectorTable";
import ImportarNominasSection from "./importarNominas/ImportarNominasSection";

const TrabajadoresSectorContainer = ({ handleCancelResolucion, nextForm }) => {
  const dispatch = useDispatch();
  const data = useSelector(
    (state) => state.resolucion.postResolucion.trabajadores
  );
  const nomina = useSelector((state) => state.nomina.nominaActivaCombo.data);
  const sectores = useSelector((state) => state.resolucion.sectores.data);
  const sustancias = useSelector((state) => state.resolucion.sustancias.data);
  const [editingRow, setEditingRow] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const idDependenciaEmpleador = useSelector(
    (state) => state.resolucion.searchedEstablecimiento
  );
  useEffect(() => {
    if (sectores.length === 0) {
      dispatch(getSectores(idDependenciaEmpleador));
    }
    if (nomina.length === 0) {
      const fechaPresentacion = new Date().toISOString().split('T')[0];
      dispatch(getNominaActivaComboBox(idDependenciaEmpleador, fechaPresentacion));
    }
    if (!sustancias || sustancias.length === 0) {
      dispatch(getSustancias());
    }
  }, []);

  const handleOpenFormularioTrabajador = (row) => {
    setEditingRow(row);
    setShowForm(true);
  };

  const handleDelete = (rows) => {
    dispatch(removeTrabajadores(rows));
  };

  const handleImportSuccess = (workers) => {
    // Primero borrar todos los trabajadores existentes usando sus índices
    if (data.length > 0) {
      const indices = data.map((_, index) => index);
      dispatch(removeTrabajadores(indices));
    }

    // Luego agregar los trabajadores importados
    workers.forEach((worker) => {
      dispatch(addTrabajador(worker));
    });
  };

  return (
    <div>
      {showForm ? (
        <TrabajadoresFormContainer
          editingRow={editingRow}
          setShowForm={setShowForm}
        />
      ) : (
        <>
          <TrabajadoresSectorTable
            data={data}
            handleOpenFormularioTrabajador={handleOpenFormularioTrabajador}
            handleDelete={handleDelete}
            handleCancelResolucion={handleCancelResolucion}
          />
          <ImportarNominasSection onImportSuccess={handleImportSuccess} />
        </>
      )}
    </div>
  );
};

export default TrabajadoresSectorContainer;

